export default __webpack_public_path__ + "static/media/pp2.fa78145c.png";